define("shared/components/shared/emoji-textarea", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "shared/utils/emoji-picker", "shared/utils/insert-text-at-cursor", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _emberConcurrency, _emojiPicker, _insertTextAtCursor, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _getElement, _logInitializationError;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"shared/utils/emoji-picker",0,"shared/utils/insert-text-at-cursor",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(receiver, privateSet, fn) { _assertClassBrand(privateSet, receiver); return fn; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="emojionearea {{if @class @class}}" {{did-insert this.initialize}}>
    <div class="u--relative">
      {{yield}}
      <Textarea
        name={{@name}}
        placeholder={{@placeholder}}
        @value={{@value}}
        class={{concat-classes
          "cPM--post__textarea e--modal__captionTextarea e--autosize qa--emoji_textarea"
          (if @showRichText "cPM--post__textarea--transparent")
        }}
        data-test-id="emoji textarea"
        disabled={{@isDisabled}}
        {{autofocus @autofocus}}
        {{autoresize @value}}
        ...attributes
        {{did-update (if @showRichText @updateRichText (noop)) @value}}
        {{on "focusin" this.focusIn}}
        {{on "focusout" this.focusOut}}
      />
    </div>
  
    <div class="cPM--composerTool cPM--composerTool--emoji emojionearea-button-root" data-test-id="emoji-button-wrapper">
      {{#if this.isUnsupportedBrowser}}
        <EmberTooltip @event="hover" @side="left">
          <span class="u--text--base" data-test-id="browser-tooltip">
            {{t "post.body.feature_not_available_emojis_unsupported"}}
          </span>
        </EmberTooltip>
      {{/if}}
  
      <Shared::Ui::Button
        @class={{if this.emojiAreaActive "is--active"}}
        @isDisabled={{this.isUnsupportedBrowser}}
        @onClick={{this.togglePicker}}
        @variant="unstyled"
        class="cPM--composerTool__item emojionearea-button-trigger {{if @buttonClass @buttonClass}}"
        data-test-id="emoji button"
      >
        {{svg-jar "emoji-smile" class="o--icon--sm"}}
        {{#if @displayText}}
          <span class={{@displayTextClass}}>{{@displayText}}</span>
        {{/if}}
      </Shared::Ui::Button>
    </div>
  </div>
  */
  {
    "id": "tcWqjscc",
    "block": "[[[11,0],[16,0,[29,[\"emojionearea \",[52,[30,1],[30,1]]]]],[4,[38,1],[[30,0,[\"initialize\"]]],null],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--relative\"],[12],[1,\"\\n    \"],[18,13,null],[1,\"\\n    \"],[8,[39,3],[[16,3,[30,2]],[16,\"placeholder\",[30,3]],[16,0,[28,[37,4],[\"cPM--post__textarea e--modal__captionTextarea e--autosize qa--emoji_textarea\",[52,[30,4],\"cPM--post__textarea--transparent\"]],null]],[24,\"data-test-id\",\"emoji textarea\"],[16,\"disabled\",[30,5]],[17,6],[4,[38,5],[[30,8]],null],[4,[38,6],[[30,7]],null],[4,[38,7],[[52,[30,4],[30,9],[28,[37,8],null,null]],[30,7]],null],[4,[38,9],[\"focusin\",[30,0,[\"focusIn\"]]],null],[4,[38,9],[\"focusout\",[30,0,[\"focusOut\"]]],null]],[[\"@value\"],[[30,7]]],null],[1,\"  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"cPM--composerTool cPM--composerTool--emoji emojionearea-button-root\"],[14,\"data-test-id\",\"emoji-button-wrapper\"],[12],[1,\"\\n\"],[41,[30,0,[\"isUnsupportedBrowser\"]],[[[1,\"      \"],[8,[39,10],null,[[\"@event\",\"@side\"],[\"hover\",\"left\"]],[[\"default\"],[[[[1,\"\\n        \"],[10,1],[14,0,\"u--text--base\"],[14,\"data-test-id\",\"browser-tooltip\"],[12],[1,\"\\n          \"],[1,[28,[35,11],[\"post.body.feature_not_available_emojis_unsupported\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[8,[39,12],[[16,0,[29,[\"cPM--composerTool__item emojionearea-button-trigger \",[52,[30,10],[30,10]]]]],[24,\"data-test-id\",\"emoji button\"]],[[\"@class\",\"@isDisabled\",\"@onClick\",\"@variant\"],[[52,[30,0,[\"emojiAreaActive\"]],\"is--active\"],[30,0,[\"isUnsupportedBrowser\"]],[30,0,[\"togglePicker\"]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,13],[\"emoji-smile\"],[[\"class\"],[\"o--icon--sm\"]]]],[1,\"\\n\"],[41,[30,11],[[[1,\"        \"],[10,1],[15,0,[30,12]],[12],[1,[30,11]],[13],[1,\"\\n\"]],[]],null],[1,\"    \"]],[]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@class\",\"@name\",\"@placeholder\",\"@showRichText\",\"@isDisabled\",\"&attrs\",\"@value\",\"@autofocus\",\"@updateRichText\",\"@buttonClass\",\"@displayText\",\"@displayTextClass\",\"&default\"],false,[\"if\",\"did-insert\",\"yield\",\"textarea\",\"concat-classes\",\"autofocus\",\"autoresize\",\"did-update\",\"noop\",\"on\",\"ember-tooltip\",\"t\",\"shared/ui/button\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/emoji-textarea.hbs",
    "isStrictMode": false
  });
  /**
   * This component adds the picmo emoji library to a standard textarea and
   * and takes care of inserting emojis at the correct location. Picmo uses the
   * standard emoji set from the user's OS, so the emoji will look different on the
   * different browsers. Picmo automatically selects the latest Emoji version that
   * is available for the user's OS.
   *
   * @remarks Block usage is not supported
   *
   * @see https://picmojs.com/ for full documentation
   *
   * @example
   * <caption>Simple inline usage</caption>
   * ```hbs
   * <Shared::EmojiTextarea
   *   @value={{this.comment}}
   *   @class={{cPT--post_textarea}}
   *   @name={{caption}}
   *   @placeholder={{"Enter your note here"}}
   * />
   * ```
   */
  let EmojiTextareaComponent = _exports.default = (_class = (_getElement = /*#__PURE__*/new WeakSet(), _logInitializationError = /*#__PURE__*/new WeakSet(), class EmojiTextareaComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _logInitializationError);
      /**
       * Recursively tries to find an element with the given selector.
       *
       * @remarks This was added to prevent errors where the element is not immediately
       * available. This is likely due to slow rendering on some devices/browsers.
       *
       * @param query The element lookup query
       * @param retries The number of times to retry
       */
      _classPrivateMethodInitSpec(this, _getElement);
      _initializerDefineProperty(this, "errors", _descriptor, this);
      _initializerDefineProperty(this, "locale", _descriptor2, this);
      _defineProperty(this, "textAreaSelector", 'textarea');
      _defineProperty(this, "rootElementSelector", '.emojionearea-button-root');
      _defineProperty(this, "triggerElementSelector", '.emojionearea-button-trigger');
      _initializerDefineProperty(this, "picker", _descriptor3, this);
      _initializerDefineProperty(this, "showDropdown", _descriptor4, this);
      _initializerDefineProperty(this, "textarea", _descriptor5, this);
      _initializerDefineProperty(this, "emojiAreaActive", _descriptor6, this);
    }
    get isUnsupportedBrowser() {
      return !document.body.replaceChildren;
    }
    willDestroy() {
      super.willDestroy();
      if (this.emojiAreaActive) {
        this.picker?.close();
      }
    }
    async initialize(element) {
      if (this.isUnsupportedBrowser) {
        return;
      }
      try {
        const textareaQuery = _classPrivateMethodGet(this, _getElement, _getElement2).call(this, () => element.querySelector(this.textAreaSelector));
        const rootElementQuery = _classPrivateMethodGet(this, _getElement, _getElement2).call(this, () => element.querySelector(this.rootElementSelector));
        const triggerElementQuery = _classPrivateMethodGet(this, _getElement, _getElement2).call(this, () => element.querySelector(this.triggerElementSelector));
        this.textarea = await textareaQuery;
        const rootElement = await rootElementQuery;
        const triggerElement = await triggerElementQuery;
        if (!this.textarea || !rootElement || !triggerElement) {
          _classPrivateMethodGet(this, _logInitializationError, _logInitializationError2).call(this, rootElement, triggerElement);
          return;
        }
        this.picker = (0, _emojiPicker.default)({
          locale: this.locale,
          referenceElement: triggerElement,
          rootElement,
          triggerElement
        });
        this.picker.addEventListener('emoji:select', _ref => {
          let {
            emoji
          } = _ref;
          if (this.textarea) {
            (0, _insertTextAtCursor.insertTextAtCursor)(this.textarea, emoji);
          }
        });
        this.picker.addEventListener('picker:close', () => {
          this.emojiAreaActive = this.picker ? this.picker.isOpen : false;
        });
        return;
      } catch (error) {
        this.errors.log(error);
      }
    }
    togglePicker() {
      if (!this.args.isDisabled) {
        this.picker?.toggle();
        this.emojiAreaActive = this.picker ? this.picker.isOpen : false;
      }
    }
    focusOut() {
      this.showDropdown = false;
      this.args.setErrorVisibility?.(true);
    }
    focusIn() {
      this.showDropdown = true;
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "picker", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showDropdown", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "textarea", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "emojiAreaActive", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "initialize", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "togglePicker", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "togglePicker"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focusOut", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "focusOut"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focusIn", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "focusIn"), _class.prototype)), _class);
  async function _getElement2(query) {
    let retries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    const DELAY_MS = 500;
    const element = query();
    if (element) {
      return element;
    }
    if (retries > 0) {
      await (0, _emberConcurrency.timeout)(DELAY_MS);
      return _classPrivateMethodGet(this, _getElement, _getElement2).call(this, query, retries - 1);
    }
    return null;
  }
  function _logInitializationError2(rootElement, triggerElement) {
    this.errors.log(new Error('Could not find elements for emoji picker'), {
      rootElement: {
        found: !!rootElement,
        selector: this.rootElementSelector
      },
      triggerElement: {
        found: !!triggerElement,
        selector: this.triggerElementSelector
      },
      textarea: {
        found: !!this.textarea,
        selector: this.textAreaSelector
      }
    });
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, EmojiTextareaComponent);
});